<template>
    <div class="stale-accounts-wrapper">
        <Row :gutter="32">
            <i-col :xs="12">
                <Table :columns="columns" :loading="dataLoading" :data="UIlanguages">
                    <div slot-scope="{ row, index }" slot="action">
                        <Button type="error" size="small" @click="deleteLanguage(row,index)" v-if="UIlanguages.length>1">Delete</Button>
                    </div>
                </Table>
            </i-col>
            <i-col :xs="12">
                <div class="add-form">
<!--                    <AutoComplete v-model="selectedLanguage"-->
<!--                                  placeholder="Language"-->
<!--                                  placement="bottom"-->
<!--                                  :data="languages"-->
<!--                                  :filter-method="filterMethod"-->
<!--                                  clearable>-->
<!--                    </AutoComplete>-->
                    <Select v-model="selectedLanguage" filterable placeholder="Select language">
                        <Option v-for="lang in languages" :value="lang.name.toLowerCase()" :key="lang.code">{{ lang.name }}</Option>
                    </Select>
                    <Button type="primary" @click="addLanguage" style="margin-top: 16px" long>Add language</Button>
                </div>
            </i-col>
        </Row>
    </div>
</template>

<script>
    import { bus } from "../../main";
    import { languages } from "../../_services/languages"
    import { getSupportedLanguages, addSupportedLanguage, deleteSupportedLanguage } from "../../_services/language.service";

    export default {
        data() {
            return {
                languages: [],
                selectedLanguage: null,
                columns: [
                    {
                        title: "Supported languages",
                        key: "LanguageName",
                        className: "capitalize"
                    },
                    {
                        title: " ",
                        slot: "action",
                        width: 150,
                        align: "right"
                    }
                    
                ],
                UIlanguages: [],
                dataLoading:true
            };
        },
        methods: {
            getUILanguageList() {
                this.dataLoading=true
                getSupportedLanguages().then(res=>{
                    this.UIlanguages=res.data.data
                    this.dataLoading=false
                }).catch(err=>{
                    bus.$emit('requestError',err)
                    this.dataLoading = false
                })
            },
            addLanguage(){
                if(this.selectedLanguage) {
                    let existingLang = this.UIlanguages.filter(({LanguageName}) => {
                        return LanguageName === this.selectedLanguage
                    })
                    if(existingLang.length===0) {
                        let lang = languages.filter(({name}) => {
                            console.log(name)
                            return name.toLowerCase() === this.selectedLanguage
                        })[0]
                        addSupportedLanguage({LanguageName:this.selectedLanguage,LanguageCode:lang.code}).then(res=>{
                            this.getUILanguageList()
                            this.$Message.success("Successfully added language.");
                        }).catch(err=>{
                            bus.$emit('requestError',err)
                            this.$Message.error("Failed to add language. Please try again later.");
                        })

                    }else {
                        this.$Notice.warning({
                            title: 'Language exist',
                            desc: `${this.selectedLanguage} is already selected`,
                        });
                    }
                }
            },
            deleteLanguage(data,index){
                this.$Modal.confirm({
                    title: 'Remove Language',
                    content: `<p>Are you sure you want to remove <b>${data.LanguageName}</b>?</p>`,
                    okText: 'Remove',
                    cancelText: 'Cancel',
                    onOk: () => {
                        this.dataLoading = true
                        deleteSupportedLanguage(data._id).then(res=>{
                            this.UIlanguages.splice(index,1)
                            this.dataLoading=false
                            this.$Message.success("Successfully deleted language.");
                        }).catch(err=>{
                            bus.$emit('requestError',err)
                            this.dataLoading=false
                            this.$Message.error("Failed to delete language. Please try again later.");
                        })
                    },
                });

            },
            filterMethod (value, option) {
                if(value && option) {
                    return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
                }else {
                    return ""
                }
            }
        },
        mounted() {
            // this.languages = languages.map(lang=>{return lang.name})
            this.languages = languages
            this.getUILanguageList();
        }
    };
</script>
<style scoped>
    .stale-accounts-wrapper{
        width: 800px;
    }
    .remove-all{
        margin-top: 20px;
        float: right;
    }
</style>
